import { DialogHandler, EEvents, requestSupportService, TextField, trackEvent } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { TSupportDialog, TSupportDialogTrackingContext } from "./types"
import { useState } from "react"

export function openSupportDialog({
    eventTracking,
    dialogTitle,
    dialogContent,
    request,
    addUserInput = false
}: TSupportDialog) {
    if (eventTracking?.open) {
        trackEvent(EEvents.BUTTON_CLICKED, eventTracking.open)
    }
    DialogHandler.show({
        title: dialogTitle || t("support-dialog-request-support-title"),
        content: <>
            {dialogContent || t("support-dialog-request-support-description")}
            {addUserInput &&
                <TextField
                    className="support-dialog-user-input"
                    sx={{ marginTop: 4 }}
                    placeholder={t("support-dialog-request-support-input-placeholder")}
                    variant="outlined"
                    multiline rows={4} />
            }
        </>,
        primaryBtnOnClick: () => {
            const userInput = (document.querySelector(".support-dialog-user-input textarea") as HTMLTextAreaElement)?.value
            sendSupportRequest({ request, tracking: eventTracking?.click, userInput })
        },
        primaryBtnText: t("general-request-send-btn"),
        secondaryBtnText: t("general-cancel"),
        secondaryBtnOnClick: () => {
            if (eventTracking?.cancel) {
                trackEvent(EEvents.BUTTON_CLICKED, eventTracking.cancel)
            }
            DialogHandler.hide()
        }
    })
}

export function sendSupportRequest({ request, tracking, userInput }: { userInput?: string, request: TSupportDialog["request"], tracking?: TSupportDialogTrackingContext }) {

    requestSupportService({
        message: userInput ? userInput : request?.message || "I need support on something.",
        type: request?.type || "support",
        subject: request?.subject || "Im requesting support"
    }).then(() => {
        if (tracking) {
            trackEvent(EEvents.BUTTON_CLICKED, tracking)
        }
        DialogHandler.hide()
        DialogHandler.show({
            type: "success",
            title: t("general-request-success")
        }, true)
    }).catch(() => {
        DialogHandler.hide()
        DialogHandler.show({
            type: "error",
            title: t("general-error-action")
        }, true)
    })
}